import React, { useState } from "react";

import { Button, Modal } from "react-bootstrap";

import GameService from "services/GameService";
import PublishButton from "./PublishButton";
import GameForm from "./Form";

function NewGame() {
  const [show, setShow] = useState(false);
  const [gameConfig, setGameConfig] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const publishGame = (status) => {
    console.log("PUBLISH GAME: ", gameConfig);
    GameService.createGame({
      ...gameConfig,
      status,
    }).then(() => {
      handleClose();
    });
  };

  // Final render of the Form Component
  return (
    <>
      <Button className="m-2" variant="primary" onClick={handleShow}>
        New Game
      </Button>

      <Modal show={show} onHide={handleClose} backdrop="static" fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>New Game</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GameForm value={gameConfig} onChange={setGameConfig} />
        </Modal.Body>
        <Modal.Footer>
          <Button className="ms-auto" variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <PublishButton canDuplicate={false} status={gameConfig.status} onClick={publishGame} disabled={!gameConfig.name || gameConfig.rounds?.length === 0} />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NewGame;
